var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Typography, IconButton, Grid, } from '@mui/material';
import { DeleteIcon, EditIcon, ExpandIcon } from '../atoms/Icons';
import DownloadDocumentList from '../atoms/DownloadDocumentList';
var StyledAccordionDetails = styled(AccordionDetails)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: 120px;\n  margin-right: 24px;\n"], ["\n  padding-left: 120px;\n  margin-right: 24px;\n"])));
var StyledAccordionSummary = styled(AccordionSummary)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  pointer-events: none;\n"], ["\n  pointer-events: none;\n"])));
var StyledIconButton = styled(IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  pointer-events: auto;\n"], ["\n  pointer-events: auto;\n"])));
var summaryColumns = [
    'swiftCode',
    'beneficiaryBankName',
    'beneficiaryBankBranch',
    'beneficiaryBankAddress',
    'accountNumber',
];
var detailColumns = [
    'recipientCompanyName',
    'recipientName',
    'recipientAddress',
    'recipientPhoneNumber',
    'recipientEmailAddress',
    'intermediaryBankSwiftCode',
    'intermediaryBankName',
    'intermediaryBankBranch',
    'intermediaryBankAddress',
];
var BankAccount = function (_a) {
    var bankAccount = _a.bankAccount, onDelete = _a.onDelete, onEdit = _a.onEdit;
    var t = useTranslation().t;
    var _b = React.useState(false), expand = _b[0], setExpand = _b[1];
    return (React.createElement(Accordion, { expanded: expand, color: "secondary" },
        React.createElement(StyledAccordionSummary, { expandIcon: React.createElement(StyledIconButton, { onClick: function () { return setExpand(!expand); } },
                React.createElement(ExpandIcon, null)) },
            React.createElement(AccordionActions, null,
                React.createElement(StyledIconButton, { onClick: function () { return onDelete(bankAccount.id); } },
                    React.createElement(DeleteIcon, null)),
                React.createElement(StyledIconButton, { onClick: onEdit },
                    React.createElement(EditIcon, null))),
            React.createElement(Grid, { container: true, spacing: 1 }, summaryColumns.map(function (column) { return (React.createElement(React.Fragment, null,
                React.createElement(Grid, { item: true, xs: 4 },
                    React.createElement(Typography, { variant: "subtitle2" }, t("params.producerBankAccount.".concat(column)) + ':')),
                React.createElement(Grid, { item: true, xs: 8 },
                    React.createElement(Typography, { variant: "subtitle2" }, bankAccount[column])))); }))),
        React.createElement(StyledAccordionDetails, null,
            React.createElement(Grid, { container: true, spacing: 1 }, detailColumns.map(function (column) { return (React.createElement(React.Fragment, null,
                React.createElement(Grid, { item: true, xs: 4 },
                    React.createElement(Typography, { variant: "subtitle2" }, t("params.producerBankAccount.".concat(column)) + ':')),
                React.createElement(Grid, { item: true, xs: 8 },
                    React.createElement(Typography, { variant: "subtitle2" }, bankAccount[column])))); })),
            React.createElement(DownloadDocumentList, { documents: bankAccount.documents }))));
};
export default BankAccount;
var templateObject_1, templateObject_2, templateObject_3;
